import { render, staticRenderFns } from "./CreatorServiceTag.vue?vue&type=template&id=1c3023d8&scoped=true&"
import script from "./CreatorServiceTag.vue?vue&type=script&lang=ts&"
export * from "./CreatorServiceTag.vue?vue&type=script&lang=ts&"
import style0 from "./CreatorServiceTag.vue?vue&type=style&index=0&id=1c3023d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3023d8",
  null
  
)

export default component.exports